import { PIXIElement } from "slotworks/graphics/pixi/group";
import * as TweenJS from "slotworks/utils/tween";
import Timer from "slotworks/utils/timer";
import Layers from "slotworks/graphics/layers/layers";
import Point from "slotworks/utils/geom/point";

export function Shake(target:PIXIElement, duration:number, offsetX:number, offsetY: number, repeat:number) {
    let startX = target.position.x;
    let startY = target.position.y;
    var p0 = {x: startX, y: startY}
    const tween = new TweenJS.Tween(p0)
    .to({x: startX + offsetX, y: startY + offsetY}, duration)
    .repeat(repeat)
    .yoyo(true)
    .onUpdate(function () {
        target.position.x = p0.x;
        target.position.y = p0.y;
    })
    .onStop(function(){
        target.position.x = startX;
        target.position.y = startY;
    })
    .onComplete(function () {
        target.position.x = startX;
        target.position.y = startY;
    })
    .start();
    
    return tween;
}


let currentTween: TweenJS.Tween = null;
export function ShakeLayers(layers: Layers[], duration: number, offsetX: number, offsetY: number, repeat: number) {
    if(currentTween != null) {
        currentTween.stop();
        currentTween = null;
    }
    var obj = {x: 0, y: 0}
    const initials: Point[] = [];
    for(let layerId in layers) {
        initials[layerId] = new Point(layers[layerId].container.x, layers[layerId].container.y)
    }
    const complete = () => {
        for(let layerId in layers) {
            const layer = layers[layerId];
            if(layer.bounds) {
                layer.container.x = layer.bounds.x;
                layer.container.y = layer.bounds.y;
            } else {
                layer.container.x = initials[layerId].x;
                layer.container.y = initials[layerId].y;
            }
        }
    }
    const tween = new TweenJS.Tween(obj)
    .to({x: offsetX, y: offsetY}, duration)
    .repeat(repeat)
    .yoyo(true)
    .easing(TweenJS.Easing.Quartic.InOut)
    .interpolation(TweenJS.Interpolation.Bezier)
    .onUpdate(function () {
        for(let layerId in layers) {
            layers[layerId].container.x = initials[layerId].x + obj.x;
            layers[layerId].container.y = initials[layerId].y + obj.y;
        }
    })
    .onStop(complete)
    .onComplete(complete);
    currentTween = tween;
    tween.start();
    
    return tween;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/commands/shake-command.ts